<template>
    <div :style="indent">
        <!-- opened-sifarnik - na root ako nema parrenta -->
        <!--  -->
        <div @click="showChildren = !showChildren" class="radnja-tbr-main-wrapper"
            v-if="sifra.children.length > 0 || sifra.parrent_id == null">
            <div :class="['main-tbr',showChildren ? 'active' : '']">
                <div class="number-name-wrapper">
                    <div class="tbr-name-wrapp" >
                        <div class="tbr-number"><div>{{sifra.number != null ? sifra.number : ''}}</div></div>
                        <div class="tbr-name">{{sifra.name != null ? sifra.name : ''}}</div>
                    </div>
                </div>
                <div class="tbr-more-svg"><svg xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:avocode="https://avocode.com/" id="SVGDoc"
                        width="14" height="9" version="1.1" viewBox="0 0 14 9">
                        <defs />
                        <desc>Generated with Avocode.</desc>
                        <g>
                            <g>
                                <title>Vector</title>
                                <path d="M0.99946,0.99986v0l6.00028,6.00014v0l6.00016,-6.00014v0" fill-opacity="0"
                                    fill="#ffffff" stroke-dashoffset="0" stroke-dasharray="" stroke-linejoin="miter"
                                    stroke-linecap="butt" stroke-opacity="1" stroke="#3326ae" stroke-miterlimit="20"
                                    stroke-width="2.0000000000000018" />
                            </g>
                        </g>
                    </svg></div>
            </div>
        </div>
        <div class="sub-tbr act" v-else>
            <div class="number-name-wrapper">
                <div class="tbr-name-wrapp" >
                    <div class="tbr-number"><div>{{sifra.number}}</div></div>
                    <div class="tbr-name">{{sifra.name}}
                        <div class="info-button" @click="showDetails(sifra)">i</div>
                    </div>
                </div>
                <div class="points-box-wrapper">
                    <div class="tbr-points" @click="showDetails(sifra)">{{sifra.value != null && sifra.value > 0 ? sifra.value : '?'}}</div>
                    <div class="task-checkbox-container">
                        <!-- spinner koji se aktivira na klik i traje dok se ne izvrsi update -->
                        <svg class="update-event-spin popup-event-spin" viewBox="0 0 50 50" style="display:none">
                            <circle class="path" cx="25" cy="25" r="20" fill="none" stroke-width="8"></circle>
                        </svg>
    
                        <div :class="['task-checkbox', 'popup-check', is_active ? 'active' : '']"
                            @click="!is_active ? addToList(sifra) : removeFromList(sifra)">
                            <div class="check"></div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
        <single-sifra-tarife
            v-show="showChildren"
            v-for="(sub, ky) in sifra.children"
            :key="ky"
            :sifra="sub"
            :radnje="radnje"
            :depth="depth + 1"
            @tmpadd="addToList"
            @tmpremove="removeFromList"
            @show_details="showDetails"
        />
        </div>
</template>
<script>
import SingleSifraTarife from "@/components/costSheetComponents/sifarnik/SingleSifraTarife.vue";
import $ from 'jquery';
export default {
    name: "single-sifra-tarife",
    props: ["sifra", "depth", "radnje"],
    components: {
        SingleSifraTarife
    },
    computed: {
        indent() {
            return { paddingLeft: this.depth>0 ? 2.5 + "rem" : '0rem' }
        },
        is_active() {
            const active = this.radnje.map(r=>r.uid).includes(this.sifra.uid)
            return active;
        }
        // indent() {
        //     var sirina = (86 - (this.depth*4)) + "rem";
        //     var margin = (4*this.depth)+"rem";
        //     return { width: sirina, marginLeft : margin };
        // },
    },
    data() {
        return {
            showChildren: false,
        }
    },
    methods: {
        addToList(node){
            this.$emit("tmpadd", node);
        },
        removeFromList(node){
            this.$emit("tmpremove", node);
        },
        showDetails(node){
            this.$emit("show_details", node);
        }
    }
}

</script>
  
<style>

</style>